import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Box,
  useMediaQuery,
  Stack,
} from "@mui/material";
import dayjs from "dayjs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";

import PendingPutAwayGrid, {
  Detail_Loading,
  G1_PendingPO_LoadDetail_Column,
  G1_PendingRCV_LoadDetail_Column,
  G1_POVarience_LoadDetail_Column,
  G2_PendingPutAway_LoadDetail_Column,
  G5_PickingProgressDetail_LoadDetail,
  G5_PickingProgressDetail_LoadDetail_Column,
  Summary_Columns_Def,
  G2_PendingPutAwayDetail_LoadDetail_Column,
  G4_SalesInvoice_LoadDetail_Column,
  getPurchaseGrnVariance,
  G2_PendingPutAwayDetail_LoadDetail,
} from "../WmsDashboardAction";
import GCData from "./GCDataGrid";

import { CmpButton } from "../../../Component/Common/ToolBox/ToolBox";
import { Drawer } from "@mui/material";
import GCModal from "./GCModal";

import GCDetail from "./GCDetail";
import PoVsGrn from "./POVsGRNVariance";
import { useNavigate } from "react-router-dom";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { IconButton, Tooltip } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { getUniqueValues } from "../../../Utility/Utilitys";

export default function AccordianWrap({
  headerList = [],
  GetSummary = () => {},
}) {
  const vMediaQuery = useMediaQuery("max-width:650px");
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [column, setColumn] = useState(Summary_Columns_Def);
  const [row, setrow] = useState([]);
  const apiRef = useGridApiRef();

  const init = {
    Type: "",
    VoucherTypeName: "",
    VoucherTypeCode: "",
    RefDate: new Date(),
    VoucherNo: "",
    Version: "",
    PartyCode: "",
    PartyName: "",
    ExpiryDate: new Date(),
    PoNetAmount: 0,
    NoOfLineItems: 0,
    GRNDate: new Date(),
    InvNo: "",
    InvDate: new Date(),
    AllocateReceiver: "",
    AllocateReceiverName: "",
    UnloadingBay: "",
    UnloadingBayName: "",
    ExpStartTime: dayjs().format("hh:mm:ss"),
    ExpFinishTime: dayjs().format("hh:mm:ss"),
    TotalTimeinMin: 0,
    GRNNetAmt: "",
    NoOfItems: "",
    Location: "",
    A_RefTyp: "",
    A_RefName: "",
    A_RefDocNo: "",
    btnPost: true,
    btnSave: true,
    btnReverse: true,
    btnDelete: true,
  };
  const inittitle = {
    modalTitle: "",
    trntype: "",
  };

  const [sHead, setHead] = useState(init);
  const [sDrawerTitle, setDrawerTitle] = useState(inittitle);
  //modal
  const [pickingTitle, setPickingTitle] = useState("");
  //endModal
  // modal start
  const [showSubModal, setShowSubModal] = useState(false);
  const [sSubTitle, setSubTitle] = useState("Modal");
  const [sSubobj, setSubobj] = useState({ A_VocNo: "", A_VocTyp: "" });
  const [subColumn, setSubColumn] = useState(Summary_Columns_Def);
  const [SubRow, setSubRow] = useState([]);
  const [sTitle, setTitle] = useState("Modal");
  // modal end

  //povsGRNModal start
  const [openModal, setOpenModal] = useState(false);
  const [sPoVsGRNRow, setPoVsGRNRow] = useState([]);
  const [data, setdata] = useState({});
  //poVs Grn End

  //drawer
  const [showDrawer, setShowDrawer] = useState(false);

  //drawerEnd

  const fRowClick = async (rowObj, trntype) => {
    // setShowModal(true);

    let data = await Detail_Loading(rowObj?.Header, rowObj?.TrnTyp);
    setrow((prev) => ({
      ...prev,
      [rowObj.Transaction]: {
        data,
        fetched: true,
      },
    }));
    setDrawerTitle({
      modalTitle: rowObj?.Transaction,
      trntype: trntype,
    });
    setPickingTitle({
      trnType: trntype,
    });
  };

  console.log("row", row);

  const fIconClick = async (e) => {
    console.log(e.row);

    setSubTitle(sTitle + " ( VocNo " + e?.row?.A_VocNo + ")");
    setSubColumn(G5_PickingProgressDetail_LoadDetail_Column);

    await G5_PickingProgressDetail_LoadDetail(
      setSubRow,
      e?.row?.A_VocNo,
      e?.row?.A_VocTyp
    );

    setShowSubModal(true);
  };

  const fGridRowClick = async (e) => {
    console.log(e, "e");

    if (
      sTitle == "Pending PO" ||
      sTitle == "Pending Sales Return" ||
      sTitle == "Pending Transfer Return"
    ) {
      let {
        VocType = "",
        VocName = "",
        VocNo = "",
        A_RefNo = "",
        PostDt = "",
        ExpDate = "",
        PartyCode = "",
        PartyName = "",
        POAmount = "",
        NoofItem = "",
      } = e.row;
      setHead((obj) => ({
        ...obj,
        VoucherTypeName: VocName,
        VoucherTypeCode: VocType,
        RefDate: PostDt,
        VoucherNo: VocNo,
        // Version:"",
        Type:
          sDrawerTitle.trntype == "P"
            ? "VENDOR_INV"
            : sDrawerTitle.trntype == "T"
            ? "TRANSFER_RETURN"
            : "SALES_RETURN",
        PartyCode: PartyCode,
        PartyName: PartyName,
        ExpiryDate: ExpDate,
        PoNetAmount: POAmount,
        NoOfLineItems: NoofItem,
      }));

      setShowDrawer(true);
      // navigate("/WmsDashboardDetail");
    }

    if (sTitle == "Pending for Receive" || sTitle == "Receiving in Progress") {
      console.log(e?.row);

      setdata(e?.row);
      setSubTitle(sTitle + " ( VocNo " + e?.row?.VocNo + ")");
      await getPurchaseGrnVariance(setPoVsGRNRow, e?.row);
      setOpenModal(true);
    }

    if (sTitle == "Un-assigned GRN") {
      console.log(e?.row);
      // navigate("/wmsPutawayGeneration", {
      //   state: {
      //     VocTyp: e?.row?.A_VocTyp,
      //     VocNo: e?.row?.A_VocNo,
      //     RefNo: e?.row?.A_RefNo,
      //   },
      // });

      //open new tab
      const data = {
        VocTyp: e?.row?.A_VocTyp,
        VocNo: e?.row?.A_VocNo,
        RefNo: e?.row?.A_RefNo,
      };
      localStorage.setItem("putawayData", JSON.stringify(data));
      window.open("/wmsPutawayGeneration", "_blank");
    }
    if (sTitle == "Pending for put-away" || sTitle == "Put-away in progress") {
      console.log(e?.row);
      setSubobj({
        A_VocNo: e?.row?.A_VocNo,
        A_VocTyp: e?.row?.A_VocTyp,
      });
      setSubTitle(sTitle + " ( VocNo " + e?.row?.A_VocNo + ")");
      setSubColumn(G2_PendingPutAwayDetail_LoadDetail_Column);
      await G2_PendingPutAwayDetail_LoadDetail(
        setSubRow,
        e?.row?.A_VocNo,
        e?.row?.A_VocTyp
      );
      setShowSubModal(true);
    }
    if (sDrawerTitle.trntype == "WMPKNG") {
      console.log(e.row);

      setSubTitle(sTitle + " ( VocNo " + e?.row?.A_VocNo + ")");
      setSubColumn(G5_PickingProgressDetail_LoadDetail_Column);
      await G5_PickingProgressDetail_LoadDetail(
        setSubRow,
        e?.row?.A_VocNo,
        e?.row?.A_VocTyp
      );
      setShowSubModal(true);
    }
    if (sDrawerTitle.trntype == "Pending for post") {
      console.log(e?.row);
      // navigate("/PutAwayDetail", {
      //   state: {
      //     GRNDocTyp: e?.row?.A_VocTyp,
      //     GrnDocNo: e?.row?.A_VocNo,
      //     PUTAWAYFromNotification: "N",
      //   },
      // });

      //open new tab
      const data = {
        GRNDocTyp: e?.row?.A_VocTyp,
        GrnDocNo: e?.row?.A_VocNo,
        PUTAWAYFromNotification: "N",
      };
      localStorage.setItem("putawayData", JSON.stringify(data));
      window.open("/PutAwayDetail", "_blank");
    }
    //Navigate to PickingPendingList when rowclick on Picking in Progress and Picking for Post
    if (
      pickingTitle.trnType == "WMPKNGPG" ||
      pickingTitle.trnType == "PENDINGPOST"
    ) {
      console.log(e?.row);

      //detailObj for pickingPendingList (make resuable) by Ramesh Sir on Dec 26 2025
      navigate("/PickingPendingList", {
        state: {
          entrySource: "Dashboard",
          current: "PickingPendingList",
          A_VocTyp: e?.row?.A_VocTyp,
          VocName: e?.row?.VocName,
          A_VocNo: e?.row?.A_VocNo,
          A_Loc: e?.row?.A_Loc[0],
          A_Typ: e?.row?.A_Type,
          A_PKL_DocStatus: e?.row?.A_PKL_DocStatus,
          A_DocStat: e?.row?.A_DocStat[0],
          LoadingBayCode: e?.row?.A_LDBAY,
          LoadingBayName: e?.row?.LDBAYName,
        },
      });
    }
  };
  console.log("sDrawerTitle", sDrawerTitle, pickingTitle, row);

  const handleExpand = async (panel, rowObj) => {
    const isExpanded = expanded === panel ? false : panel;
    setExpanded(isExpanded);

    // Fetch data only if not already fetched
    let trntype =
      rowObj.Transaction == "Pending PO"
        ? "P"
        : rowObj.Transaction == "Pending Transfer Return"
        ? "T"
        : rowObj.Transaction == "Pending Sales Return"
        ? "R"
        : rowObj.Transaction == "Pending for Receive"
        ? "RECEIVING"
        : rowObj.Transaction == "Receiving in Progress"
        ? "RECVPRGS"
        : //  rowObj.Transaction == "Pending for verification" ? "":
        rowObj.Transaction == "Un-assigned GRN"
        ? "UNASSIGN"
        : rowObj.Transaction == "Pending for put-away"
        ? "PENDING"
        : rowObj.Transaction == "Put-away in progress"
        ? "PROGRESS"
        : rowObj.Transaction == "Pending for post"
        ? "PENDINGPOST"
        : rowObj.Transaction == "Purchase Return"
        ? "WMINV04"
        : rowObj.Transaction == "Sales Invoice"
        ? "WMINV08"
        : rowObj.Transaction == "Stock Transfer"
        ? "WMINV10"
        : rowObj.TrnTyp == "WMPKNG" ||
          rowObj.TrnTyp == "WMPKNGPG" ||
          rowObj.TrnTyp == "WMINV08" ||
          rowObj.TrnTyp == "INV02" ||
          rowObj.TrnTyp == "WMINV04" ||
          rowObj.TrnTyp == "WMTSR" ||
          rowObj.TrnTyp == "WMPKLST" ||
          rowObj.TrnTyp == "ORD002" ||
          rowObj.TrnTyp == "WMINV11"
        ? rowObj.TrnTyp
        : "";
    setTitle(rowObj?.Transaction);
    if (
      rowObj.Transaction == "Pending PO" ||
      rowObj.Transaction == "Pending Sales Return" ||
      rowObj.Transaction == "Pending Transfer Return"
    ) {
      setColumn(G1_PendingPO_LoadDetail_Column);
    }
    if (
      rowObj.Transaction == "Pending for Receive" ||
      rowObj.Transaction == "Receiving in Progress"
    ) {
      setColumn(G1_PendingRCV_LoadDetail_Column);
    }
    if (rowObj.Transaction == "Pending for verification") {
      setColumn(G1_POVarience_LoadDetail_Column);
    }

    if (
      rowObj.Transaction == "Un-assigned GRN" ||
      rowObj.Transaction == "Pending for put-away" ||
      rowObj.Transaction == "Put-away in progress" ||
      rowObj.Transaction == "Pending for post"
    ) {
      setColumn(G2_PendingPutAway_LoadDetail_Column);
    }

    if (
      rowObj.Transaction == "Sales Invoice" ||
      rowObj.Transaction == "Purchase Return" ||
      rowObj.Transaction == "Stock Transfer" ||
      rowObj.TrnTyp == "INV02" ||
      rowObj.TrnTyp == "WMINV04" ||
      rowObj.TrnTyp == "WMINV08" ||
      rowObj.TrnTyp == "WMINV09" ||
      rowObj.TrnTyp == "WMINV10" ||
      rowObj.TrnTyp == "WMINVDO" ||
      rowObj.TrnTyp == "WMINV11" ||
      rowObj.TrnTyp == "WMTSR" ||
      rowObj.TrnTyp == "WMPKLST" ||
      rowObj.TrnTyp == "WMLDLST" ||
      rowObj.TrnTyp == "MFDPLN" ||
      rowObj.TrnTyp == "ORD002" ||
      rowObj.TrnTyp == "ORD003" ||
      rowObj.TrnTyp == "WMPKNG" ||
      rowObj.TrnTyp == "WMPKNGPG" ||
      rowObj.TrnTyp == "WMPKNGPT"
    ) {
      setColumn(
        G4_SalesInvoice_LoadDetail_Column(
          rowObj.TrnTyp == "WMPKNGPG",
          fIconClick
        )
      );
    }

    if (
      isExpanded &&
      (!row?.[rowObj.Transaction] || !row?.[rowObj.Transaction]?.fetched)
    ) {
      fRowClick(rowObj, trntype);
    }
  };
  const reset = () => {
    setShowDrawer(false);
    GetSummary();
    setExpanded(false);
    setrow([]);
    setHead(init);
    setDrawerTitle(inittitle);
  };

  const handleExport = () => {
    apiRef.current.exportDataAsCsv(); // or exportDataAsExcel(), etc.
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  return (
    <Box>
      {Array.isArray(headerList) && headerList.length > 0 ? (
        headerList.map((item, index) => (
          <Accordion
            key={item.Transaction}
            expanded={expanded === `panel-${index}`}
            onChange={() => handleExpand(`panel-${index}`, item)}
            sx={{ mb: 1, borderRadius: 2, boxShadow: 2 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                backgroundColor: "#e6f0fb",
                borderBottom: "1px solid #90caf9",
                borderTopLeftRadius: 2,
                borderTopRightRadius: 2,
                // gap: 2,
                flexDirection: { xs: "row", sm: "row" },
                minHeight: "32px !important",
                "&.MuiAccordionSummary-root": {
                  minHeight: "32px !important",
                },
                "& .MuiAccordionSummary-content": {
                  margin: "4px 0 !important",
                },
              }}
            >
              <Grid container spacing={0.1}>
                {/* Line 1: Item Name + BarCode */}
                <Grid item xs={10} sm={5}>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {item?.Transaction}
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={3}>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {item?.Count}
                  </Typography>
                </Grid>
              </Grid>
            </AccordionSummary>

            <AccordionDetails className="p-2">
              {row[item.Transaction]?.fetched ? (
                <>
                  <Stack direction={"row"} justifyContent={"flex-end"}>
                    <Tooltip title="Export">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={handleExport}
                      >
                        <FileDownloadIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Print">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={handlePrint}
                      >
                        <PrintIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>

                  {item.Transaction == "Put-away in progress" ? (
                    <PendingPutAwayGrid rows={row} onRowClick={fGridRowClick} />
                  ) : (
                    <GCData
                      Row={row[item.Transaction].data}
                      Column={column}
                      onRowClick={(e) => {
                        fGridRowClick(e);
                      }}
                      height={"50vh"}
                      apiRef={apiRef}
                    />
                  )}
                </>
              ) : null}
              <Grid container spacing={2} className="pt-1">
                <Grid item xs={6} md={6} textAlign={"start"}>
                  {sTitle == "Pending Sales Return" && (
                    <CmpButton
                      xbtnName="Add New"
                      xOnClick={(e) => {
                        setHead(init);
                        setHead((obj) => ({
                          ...obj,
                          VoucherTypeName: "Inbound Sales Return",
                          VoucherTypeCode: "SR001",
                          VoucherNo: "",
                          Type:
                            sDrawerTitle.trntype == "P"
                              ? "VENDOR_INV"
                              : sDrawerTitle.trntype == "T"
                              ? "TRANSFER_RETURN"
                              : "SALES_RETURN",
                        }));
                        // navigate("/WmsDashboardDetail");
                        setShowDrawer(true);
                      }}
                      xVariant="outlined"
                      xDisabled={sDrawerTitle.trntype != "R"}
                      xSize="small"
                      xId={"IdNew"}
                    />
                  )}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))
      ) : (
        <Typography></Typography>
      )}

      <GCModal
        xOpen={showSubModal}
        fCloseModal={() => {
          setSubRow([]);
          setSubColumn([]);
          setShowSubModal(false);
        }}
        xTitle={sSubTitle}
        component={
          <>
            <Stack direction={"row"} justifyContent={"flex-end"}>
              <Tooltip title="Export">
                <IconButton color="primary" size="small" onClick={handleExport}>
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Print">
                <IconButton color="primary" size="small" onClick={handlePrint}>
                  <PrintIcon />
                </IconButton>
              </Tooltip>
            </Stack>
            <GCData
              Row={SubRow}
              Column={subColumn}
              apiRef={apiRef}
              onRowClick={(e) => {
                if (
                  sTitle == "Pending for put-away" ||
                  sTitle == "Put-away in progress"
                ) {
                  console.log(e?.row);

                  // navigate("/PutAwayDetail", {
                  //   state: {
                  //     GRNDocTyp: sSubobj.A_VocTyp,
                  //     GrnDocNo: sSubobj.A_VocNo,
                  //     PUTAWAYFromNotification: "N",
                  //   },
                  // });

                  //Open new tab
                  const data = {
                    GRNDocTyp: sSubobj.A_VocTyp,
                    GrnDocNo: sSubobj.A_VocNo,
                    PUTAWAYFromNotification: "N",
                  };
                  localStorage.setItem("putawayData", JSON.stringify(data));
                  window.open("/PutAwayDetail", "_blank");
                }

                // if (true) {
                //   navigate("/WmsDashboardDetail");
                // }
              }}
              height={"70vh"}
            />
          </>
        }
      />

      <Drawer
        anchor="right"
        open={showDrawer}
        onClose={() => {
          // reset();
        }}
        PaperProps={{
          sx: { width: vMediaQuery ? "100%" : "900px", marginTop: "43px" },
        }} // Adjust width as needed
      >
        {/* <GCTitleSticky title={sTitle} onClose={() => {setShowDrawer(false);GetSummary(); }} /> */}

        {/* Replace below with your actual form or component */}
        <Box sx={{ paddingX: 2, paddingY: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: "#1976d2",
              paddingTop: "10px",
              textDecoration: "underline",
            }}
          >
            {sTitle}
          </Typography>
          <GCDetail
            vRdxWmsHead={sHead}
            reset={() => {
              reset();
            }}
            setHead={setHead}
            init={init}
            sDrawerTitle={sDrawerTitle}
          />

          {/* You can add form fields or a separate form component here */}
        </Box>
      </Drawer>

      <GCModal
        xOpen={openModal}
        fCloseModal={() => {
          setOpenModal(false);
        }}
        xTitle={"PO Vs GRN - Variance"}
        component={
          <>
            <PoVsGrn
              data={data}
              row={sPoVsGRNRow}
              column={[
                { field: "SrNo", headerName: "Sr.No", width: 100, hide: true },
                { field: "B_ItmCd", headerName: "Item Code", width: 150 },
                { field: "ItemName", headerName: "Item Name", width: 200 },
                {
                  field: "POQty",
                  headerName: "PO.Qty",
                  type: "number",
                  width: 150,
                },
                {
                  field: "POAmt",
                  headerName: "PO.Amt",
                  type: "number",
                  width: 150,
                },
                {
                  field: "GRNQty",
                  headerName: "GRN.Qty",
                  type: "number",
                  width: 150,
                },
                {
                  field: "GRNAmt",
                  headerName: "GRN.Amt",
                  type: "number",
                  width: 150,
                },
                {
                  field: "DiffQty",
                  headerName: "Qty.Var",
                  type: "number",
                  width: 150,
                },
                {
                  field: "DiffAmt",
                  headerName: "Amt.Var",
                  type: "number",
                  width: 150,
                },
              ]}
            />
          </>
        }
      />
    </Box>
  );
}
